module.exports = __webpack_public_path__ + "img/coinapp-setting-step-two.8c5016da.png";